import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/ExplorationModels`

const Pic1 = `${FullPath}/GravityQuick-ReturnMmechanism/1_1x.png`;
const Pic2 = `${FullPath}/GravityQuick-ReturnMmechanism/2_1x.png`;
const Pic3 = `${FullPath}/GravityQuick-ReturnMmechanism/3_1x.png`;
const Pic4 = `${FullPath}/GravityQuick-ReturnMmechanism/4_1x.png`;
const Pic5 = `${FullPath}/GravityQuick-ReturnMmechanism/5_1x.png`;
const Pic6 = `${FullPath}/GravityQuick-ReturnMmechanism/6_1x.png`;
const Pic7 = `${FullPath}/GravityQuick-ReturnMmechanism/7_1x.png`;
const Pic8 = `${FullPath}/GravityQuick-ReturnMmechanism/8_1x.png`;
const Pic9 = `${FullPath}/GravityQuick-ReturnMmechanism/9_1x.png`;
const Pic10 = `${FullPath}/GravityQuick-ReturnMmechanism/10_1x.png`;
const Pic11 = `${FullPath}/GravityQuick-ReturnMmechanism/11_1x.png`;
const Pic12 = `${FullPath}/GravityQuick-ReturnMmechanism/12_1x.png`;
const Pic13 = `${FullPath}/GravityQuick-ReturnMmechanism/13_1x.png`;
const Pic14 = `${FullPath}/GravityQuick-ReturnMmechanism/14_1x.png`;
const Pic15 = `${FullPath}/GravityQuick-ReturnMmechanism/15_1x.png`;
const Pic16 = `${FullPath}/GravityQuick-ReturnMmechanism/16_1x.png`;
const Pic17 = `${FullPath}/GravityQuick-ReturnMmechanism/17_1x.png`;
const Pic18 = `${FullPath}/GravityQuick-ReturnMmechanism/18_1x.png`;


export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17,
        Pic18,


    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}